import React from 'react'
import { Box, TextField, Card } from '@mui/material'
import { useLocale } from 'src/locales/useLocale'
import { MetaLines } from './MetaLines'
import { numericValidationError } from './validation'

export type EmbroideryContentProps = {
  content: string
  contentMaxLength: number
  embroideryIndex?: number
  caution?: string
  description?: string
  disabled?: boolean
  allowOnlyNumeric?: boolean
  handleContent: (selected: string, i?: number) => void
}

export const EmbroideryContentDesktop: React.FC<EmbroideryContentProps> = ({
  content,
  contentMaxLength,
  embroideryIndex,
  caution,
  description,
  disabled,
  allowOnlyNumeric = false,
  handleContent
}) => {
  const { t } = useLocale()
  const [error, setError] = React.useState<string>('')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim()
    const validationError = numericValidationError(value, allowOnlyNumeric)
    if (validationError) {
      setError(validationError)
      return
    }
    setError('')
    handleContent(value, embroideryIndex)
  }

  return (
    <Card>
      <Box fontSize={14} textAlign={'left'} pl={2} pb={1} fontWeight={'bold'}>
        {t.EMBROIDERY_CONTENTS}
      </Box>
      <Box display="flex" alignItems="center" mx={1}>
        <TextField
          maxRows={1}
          onChange={handleChange}
          variant="outlined"
          style={{ width: '100%', background: disabled ? 'gainsboro' : '#fff' }}
          defaultValue={content}
          placeholder={t.ENTER_EMBROIDERY_CONTENTS}
          inputProps={{ maxLength: contentMaxLength }}
          disabled={disabled}
          error={!!error}
          helperText={error}
        />
      </Box>
      <MetaLines contentMaxLength={contentMaxLength} caution={caution} description={description} />
    </Card>
  )
}
